import React from "react";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import ScoreCard from "../ScoreCard/ScoreCard";
import { useStyles } from "../../assets/jss/ScoreCardList";

export default function ScoreCardList(props:any) {
  const scoreCardList = props.data;
  const {isApiFailed} = props;
  const classes = useStyles();
  const handleTileClick = props.handleTileClick;
  const [hallOfFameCount, setHallOfFameCount] = React.useState();

  React.useEffect(() => {
    if (props.data) {
      const hallOfFameObj = props.data.find((item) => item.statCode === 'HALL_OF_FAME');
      if (hallOfFameObj) {
        setHallOfFameCount(hallOfFameObj.statCount)
      }
    }
  }, [props.data])
  
  return (
    <CustomGrid container>
      <CustomGrid item xs={12}>
        <CustomBox className={classes.scoreCardWrap} key={props.typeOfScore}>
          {scoreCardList && scoreCardList.length && scoreCardList.map((data, index) => (
            data.statCode !== 'HALL_OF_FAME' ?
            <CustomBox className={classes.scoreCardBox} key={`${data.label}-${index}`}>
              <ScoreCard
                selectedStatId={props.selectedStatId}
                typeOfScore={props.typeOfScore}
                handleTileClick={handleTileClick}
                scoreInfo={{
                  statId: data.statId,
                  score: data.statCode === 'MASTER_DRIVERS' ? (hallOfFameCount ? hallOfFameCount + data.statCount : data.statCount) : data.statCount,
                  label: data.label,
                  color: data.color,
                  dataLoaded: data.dataLoaded,
                  isApiFailed: isApiFailed
                }}
                showLimitedDriver={props.showLimitedDriver}
                isGroupScoped={props.isGroupScoped}
              />
            </CustomBox> : null 
          ))}
        </CustomBox>
      </CustomGrid>
    </CustomGrid>
  );
}
